import {
  campoEstaPreenchido,
  diaEstaValido,
  formularioDeParcelasValido,
  montarParcelas,
  temValorPositivo,
} from "./parcelasDaMatricula";

/**
 * Estado e regras da geração das parcelas de uma matrícula: a de matrícula mais as mensalidades.
 * Compartilhado pela tela de Mensalidades (EGerarMensalidades) e pelo modal pós-efetivação da
 * pré-matrícula (EModalGerarMensalidades), que só diferem no layout.
 *
 * Com `somenteMensalidades` (a parcela de matrícula já existe, vinda da pré-matrícula), gera só
 * as mensalidades restantes, sem uma segunda parcela de matrícula.
 */
export default {
  props: {
    matricula: { type: Object, required: true },
    somenteMensalidades: { type: Boolean, default: false },
  },
  data() {
    const turma = this.matricula.turma || {};
    const descontoDaMatricula = (campo) =>
      this.matricula[campo] !== undefined ? this.matricula[campo] : 0;
    return {
      valor_matricula: turma.valor_matricula || 0,
      valor_mensalidade: turma.valor_parcela || 0,
      desconto_1: descontoDaMatricula("desconto_1"),
      desconto_2: descontoDaMatricula("desconto_2"),
      desconto_3: descontoDaMatricula("desconto_3"),
      descontoDia: null,
      descontoDia2: null,
      descontoDia3: null,
      mesInicio: { id: 1 },
      mesFinal: { id: 12 },
      vencimento: 15,
      parcelas: [],
      cabecalhos: [
        { text: "Nº", value: "numero" },
        { text: "Referência", value: "referencia" },
        { text: "Valor", value: "valor" },
      ],
    };
  },
  created() {
    this.parcelas = montarParcelas(this.$data, this.matricula.id, this.somenteMensalidades);
  },
  methods: {
    // Gancho: quem usa o mixin pode reagir de outro jeito à geração concluída.
    aoGerarParcelas() {
      this.$emit("geradas");
    },
    campoObrigatorio(valor) {
      return campoEstaPreenchido(valor) || "Campo obrigatório";
    },
    valorMaiorQueZero(valor) {
      return temValorPositivo(valor) || "Informe um valor maior que zero";
    },
    diaObrigatorio(valor) {
      return diaEstaValido(valor) || "Informe um dia entre 1 e 31";
    },
    formularioValido() {
      return formularioDeParcelasValido(this.$data, this.somenteMensalidades);
    },
    changeParcelas() {
      this.parcelas = this.formularioValido()
        ? montarParcelas(this.$data, this.matricula.id, this.somenteMensalidades)
        : [];
    },
    async vincularParcelas() {
      if (!this.formularioValido()) {
        // Marca em vermelho cada campo obrigatório vazio, quando a tela tem o formulário com ref.
        if (this.$refs.formulario) this.$refs.formulario.validate();
        this.$handleError({ message: "Preencha todos os campos obrigatórios antes de salvar." });
        return;
      }
      this.$loaderService.open("Vinculando matrículas");
      try {
        await this.$services.parcelasService.novaParcela({ formulario: [...this.parcelas] });
        this.aoGerarParcelas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
